import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  HostListener
} from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, Validators } from '@angular/forms';
import { HelperService } from 'src/services/helperService';
import { APIService } from 'src/services/api-services/api-service';
import { APIWorkshopService } from 'src/services/api-services/api-workshop.service';
import { APIServiceAdvisorService } from 'src/services/api-services/api-serviceadvisor-service';
import { CustomerBasicData, PersonType } from 'src/services/api-services/api-interfaces/customerBasicData.interface';
import { VehicleData } from 'src/services/api-services/api-interfaces/vehicleData.interface';
import { APICustomerBasicDataService } from 'src/services/api-services/api-customer-basic-data-service';
import { VehicleDataService } from 'src/services/api-services/vehicleData-service';
import { APICustomScheduleService } from 'src/services/api-services/api-custom-schedule-service';
import { APISchedulerService } from 'src/services/api-services/api-scheduler-service';
import { ThemePalette } from '@angular/material/core';
import { _countGroupLabelsBeforeOption as _countGroupLabelsBeforeOption } from '@angular/material/core';
import { Scheduler } from '../../../../../services/api-services/api-interfaces/scheduler.interface';
import { ServiceSchedule } from '../../../../../services/api-services/api-interfaces/api-interface-service-schedule';
import { Representative } from '../../../../../services/api-services/api-interfaces/api-representative.interface';
import { typeOfService } from '../../../../../services/api-services/api-interfaces/typeOfService.interface';
import { ServiceAdvisor } from '../../../../../services/api-services/api-interfaces/ServiceAdvisor.interface';

import { APIRepresentativeService } from '../../../../../services/api-services/api-representative-service';
import moment from 'moment';
import { APIServiceSchedule } from '../../../../../services/api-services/api-service-schedule';
import { ActivatedRoute, Router } from '@angular/router';
import { Workshop } from 'src/models/workshop';
import { APIcityService } from '../../../../../services/api-services/api-city-service';
import { APIAttentionSchedule } from 'src/services/api-services/api-service-attention-schedule';
import { ServiceAttentionSchedule } from '../../../../../services/api-services/api-interfaces/api-interface-attention-schedule';
import { APIServiceAdvisorSchedule } from 'src/services/api-services/api-service-advisor-schedule';
import { ServiceAdvisorShedule } from 'src/services/api-services/api-interfaces/api-interface-service-advisor-schedule';
import { APITermsAndPolitics } from 'src/services/api-services/api-terms-and-politics.service';
import {
  tap,
  Observable,
  map,
  Subscription,
  catchError,
  of,
} from 'rxjs';
import { APIServiceAdvisorBlockedSchedule } from 'src/services/api-services/api-advisor-blocked-schedule-service';
import { ServiceAdvisorBlockedSchedule } from 'src/services/api-services/api-interfaces/api-interface-advisor-blocked-schedule';
import { APIBlockedAttentionSchedules } from '../../../../../services/api-services/api-blocked-attention-schedule';
import { APIDealerBlockedServices } from '../../../../../services/api-services/api-dealer-blocked-services';
import { unavaibleAdvisorHours } from '../../../../../services/api-services/api-interfaces/unavaibleAdvisorHours.interface';
import { CreateSchedulerData } from 'src/services/api-services/api-interfaces/api-interface-create-scheduler';
import { APIDocumentTypeService } from 'src/services/api-services/api-document-type.service';
import { TranslateService } from '@ngx-translate/core';
import { PublicSiteConfig } from 'src/services/publicSiteConfig.service';
import { MatTooltip as MatTooltip } from '@angular/material/tooltip';
import { DomSanitizer, SafeHtml, SafeUrl } from '@angular/platform-browser';
import { TermsAndPolitics } from 'src/services/api-services/api-interfaces/api-interface-terms-and-politics';
import { HttpClient } from '@angular/common/http';
import { PublicSiteConfigBaseComponent } from 'src/app/base/publicSiteConfigBase.component';

export interface Task {
  name: string;
  completed: boolean;
  color: ThemePalette;
  subtasks?: Task[];
}
declare const grecaptcha: any;
const noSpecialCharsValidator = (control: AbstractControl): {[key: string]: any} | null => {
  const noSpecialChars = /^[^*=,\/#!$%\^\*;:{}\[\]~()<>\?|]+$/;
  const forbidden = !noSpecialChars.test(control.value);
  return forbidden ? {'noSpecialChars': {value: control.value}} : null;
};
const emailValidator = (control: AbstractControl): {[key: string]: any} | null => {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  const forbidden = !emailPattern.test(control.value);
  return forbidden ? {'invalidEmail': {value: control.value}} : null;
};
@Component({
    selector: 'app-choose-service-workshop',
    templateUrl: './choose-service-workshop.component.html',
    styleUrls: ['./choose-service-workshop.component.sass'],
    standalone: false
})

export class ChooseServiceWorkshopComponent extends PublicSiteConfigBaseComponent implements OnInit, OnDestroy {
  //-------------//
  typesOfDocumentRepresentative: string[] = [
    'CC',
    'CE',
    'NIP',
    'NIT',
    'TI',
    'PAP',
  ];
  relationsRepresentativeVC: string[] = [
    'Antiguo dueño',
    'Copropiertario',
    'Conductor',
    'Persona de Contacto',
    'Otro',
  ];
  relationsVC: string[] = [
    'Dueño',
    'Antiguo dueño',
    'Copropiertario',
    'Conductor',
    'Persona de Contacto',
    'Otro',
  ];
  typeOfServices: string[] = [];
  mileages: string[] = [];


  // -----data to remove on the future to remove hardcoded values ---------
  public recievedScheduledData: any = history.state.schedule as {}
  public recievedCityData : any = history.state.cityId  as {}
  public serviceIdResponse:number = 0

  public code: string = '';

  public codeRep: string = '';
  public isLoading: boolean = false;
  public isLoadingCalendar: boolean = false;
  public showCalendar: boolean = false;
  public ToSName: any= {};
  public workShopName: string = '';
  public advisorName: string = '';
  public cityName: string = history.state.cityName;
  public FilterType:string=""
  public cityId: number = history.state.cityId;
  public workShopId: number =0
  public serviceAdvisorAttention: ServiceAdvisorShedule[] = [];
  public defaultServiceAdvisorAttention: ServiceAdvisorShedule[] = [];
  public serviceAdvisorBlockedSchedule: ServiceAdvisorBlockedSchedule[] = [];
  public unavaibleAdvisorHours: unavaibleAdvisorHours[] = [];
  public busyDates: any[] = [];
  public dealerBlockedServices: any[] = [];
  public editButton: boolean = true;
  public showForm: boolean = false;
  public isOwnerOnSite: boolean = true;
  public userSearched: boolean = false;
  isOwnerRadioChecked: boolean = true;
  public date?;
  public time = '';
  public customerBasicData?: CustomerBasicData;
  public vehicleData?: VehicleData;
  public scheduleData?: Scheduler;
  public serviceData?: ServiceSchedule;
  public representativeData?: Representative;
  public vehicleBrand: string = '';
  public typesOfservice:typeOfService[] =[];
  public typesDocument$: Observable<any[]> = new Observable< Array<any>>();
  public advisors:ServiceAdvisor[] = [];
  public workshops: Workshop[]= []
  public workshopResp: Workshop[] = [];
  public defaultWorkshops: Workshop[] = [];
  public timeButtons: string[] = [];
  public isNewUser = true;
  public workshopss!: Workshop;
  public workshopssResp: Workshop[] = [];
  //completas tus datos
  public customScheduleResp: any[] = [];
  public schedulerData: any[] = [];
  public scheduleId: any;
  public serviceSchedule;
  public customerBasicData2: CustomerBasicData[] = [];
  public vehicleDataResp;
  public scheduleDataResp;
  public servicesResp: typeOfService[] = [];
  public advisorData: ServiceAdvisor[] = [];
  public attentionScheduleWorkshop: ServiceAttentionSchedule[] = [];
  public defaultAttentionScheduleWorkshop: ServiceAttentionSchedule[] = [];
  public edited = false;
  public edited2 = false;
  public details = false;
  public userData
  public representativeDatacountry
  public SchedulForAdvisor: any[]=[];
  nameDocumentType:any =""
  public advisorId
  public bannerSuccesURL=''
  public scheduleAppointmentURL=''
  public loadingSerchPlate:boolean = false
  public brandNameOnlyPeru:string=""
  public termsPolitics?: TermsAndPolitics;
  public termsAndConditionsLink: SafeUrl="";
  public safeTermsAndConditionsDescription: SafeHtml="";
  public safeObservationsDescription: SafeHtml="";
  public dataProcessingPolicy: {[key: string]: string} = {};
  public safeDataProcessingPolicy: SafeHtml="";
  public safeDataProcessingPolicyTrue: SafeHtml="";
  public safeDataProcessingPolicyFalse: SafeHtml="";
  public TermAndConditiosMode:string = "";
  isTooltipVisible: boolean = false;
  isTooltipIconFilled: boolean = false;
  public personTypes: PersonType[] = [];
  public showApellidos: boolean = true;
  public companyType:string = "";
  public selectedPersonType: PersonType | null = null;
  @ViewChild('tooltip') tooltipIcon!: MatTooltip;
  brandUrl: string = '';
  task: Task = {
    name: 'Indeterminate',
    completed: false,
    color: 'primary',
    subtasks: [
      { name: 'Primary', completed: false, color: 'primary' },
      { name: 'Accent', completed: false, color: 'accent' },
      { name: 'Warn', completed: false, color: 'warn' },
    ],
  };

  documentType: any[]=[]
  SelectYourService:string = "Elige tu servicio"
  FinalizeReservationr:string = "Finaliza tu reserva"
  CompleteData:string = "Completa tus datos"
  public PlaceHolderObservations :string =""
  public disclaimer:string =""
  public tooltip:string = ""
  public tooltipWorkshop:string = ""
  public typeOfServiceIdSelect
  data$?: Observable<any>;
  selectOwnerOnSite:string="true"
  onPlateAndDocumentSearchSubscription?: Subscription;
  owner: boolean = true;
  recievedLanguageForCountry:any = history.state.LanguageForCountry as {}
  utmParams:any = history.state.utmParams as {}
  dateDuration:number=0
YearsShow = Array.from(
  { length: new Date().getFullYear() + 2 - 2000 },
  (_, i) => (2000 + i).toString()
).reverse();

  modelVehicle:any[]=[]
  EnableVehicleandModel = false

  // user validaction

  formValidation = this.formBuilder.group({
    tip_service: [-1, Validators.required],
    observations: [''],
    kilometraje: ['',[Validators.required, Validators.pattern(/^([0-9])*$/)]],
    taller: [null as number | null, Validators.required],
    asesor: [-1, Validators.required],
  });

  firstFormGroup = this.formBuilder.group({
    firstCtrl: ['', Validators.required],
    tip_service: ['', Validators.required],
    kilometraje: [
      '',
      {
        validators: [Validators.required, Validators.pattern(/^([0-9])*$/)],
      },
    ],
    taller: ['', Validators.required],
    asesor: ['', Validators.required],
  });

  formValidation2 = this.formBuilder.group({
    placa: ['', Validators.required],
    cedula: ['', [Validators.required ,Validators.minLength(5)]],
    personTypeId: [null as number | null],
    tip_Doc: [0, Validators.required],
    nombres: ["", [Validators.required,noSpecialCharsValidator]],
    apellidos: ["", [Validators.required,noSpecialCharsValidator]],
    cod_pais: [''],
    celular: ['',[Validators.required,noSpecialCharsValidator]],
    correo: ['', [Validators.required, emailValidator,noSpecialCharsValidator]],
    vin: [''],
    año: [, Validators.required],
    model: [, Validators.required],
    terms: [false, Validators.requiredTrue],
    politics: [null as boolean | null,Validators.required],
    isOwnerOnSite: [null, Validators.required],
    dataPeru: [null as boolean | null],
  });

  formValidation_representative = this.formBuilder.group({
    representativeDocumentType: ['', Validators.required],
    representativeDocumentNumber: ['',{
        validators: [
          Validators.required,
          Validators.pattern(/^[a-zA-Z0-9\-]*$/),
          Validators.minLength(5),
        ],
      },
    ],
    representativeName: ['', [Validators.required,noSpecialCharsValidator]],
    representativeLastName: ['',[Validators.required,noSpecialCharsValidator]],
    representativeCountryCode: [''],
    representativePhone: ['',[Validators.required,noSpecialCharsValidator]],
    representativecorreo: ['',[Validators.required, emailValidator,noSpecialCharsValidator]],
    representativeRelationWithOwner: ['', Validators.required],
    canTakeDecision: [false],
  });

  //used for validation purposes
  get cedulaControl(): FormControl {
    return this.formValidation2.get('cedula') as FormControl;
  }
  get placaControl(): FormControl {
    return this.formValidation2.get('placa') as FormControl;
  }
  get personTypeIdControl(): FormControl {
    return this.formValidation2.get('personTypeId') as FormControl;
  }
  get tip_DocControl(): FormControl {
    return this.formValidation2.get('tip_Doc') as FormControl;
  }
  get nombresControl(): FormControl {
    return this.formValidation2.get('nombres') as FormControl;
  }
  get apellidosControl(): FormControl {
    return this.formValidation2.get('apellidos') as FormControl;
  }
  get cod_paisControl(): FormControl {
    return this.formValidation2.get('cod_pais') as FormControl;
  }
  get celControl(): FormControl {
    return this.formValidation2.get('celular') as FormControl;
  }

  get correoControl(): FormControl {
    return this.formValidation2.get('correo') as FormControl;
  }
  get vinControl(): FormControl {
    return this.formValidation2.get('vin') as FormControl;
  }
  get ModelControl(): FormControl {
    return this.formValidation2.get('model') as FormControl;
  }
  get yearControl(): FormControl {
    return this.formValidation2.get('año') as FormControl;
  }
  get termsCheckedControl(): FormControl {
    return this.formValidation2.get('terms') as FormControl;
  }
  get dataProtectionPoliticsControl(): FormControl {
    return this.formValidation2.get('politics') as FormControl;
  }
  get representativeDocumentTypeControl(): FormControl {
    return this.formValidation_representative.get(
      'representativeDocumentType'
    ) as FormControl;
  }
  get representativeDocumentNumberControl(): FormControl {
    return this.formValidation_representative.get(
      'representativeDocumentNumber'
    ) as FormControl;
  }
  get representativeNameControl(): FormControl {
    return this.formValidation_representative.get(
      'representativeName'
    ) as FormControl;
  }
  get representativeLastNameControl(): FormControl {
    return this.formValidation_representative.get(
      'representativeLastName'
    ) as FormControl;
  }
  get representativeCountryCodeControl(): FormControl {
    return this.formValidation_representative.get(
      'representativeCountryCode'
    ) as FormControl;
  }
  get representativePhoneControl(): FormControl {
    return this.formValidation_representative.get(
      'representativePhone'
    ) as FormControl;
  }
  get representativeRelationWithOwnerControl(): FormControl {
    return this.formValidation_representative.get(
      'representativeRelationWithOwner'
    ) as FormControl;
  }
  get representativecorreoControl(): FormControl {
    return this.formValidation_representative.get(
      'representativecorreo'
    ) as FormControl;
  }
  get tip_serviceControl(): FormControl {
    return this.formValidation.get('tip_service') as FormControl;
  }
  get kilometrajeControl(): FormControl {
    return this.formValidation.get('kilometraje') as FormControl;
  }
  get tallerControl(): FormControl {
    return this.formValidation.get('taller') as FormControl;
  }
  get asesorControl(): FormControl {
    return this.formValidation.get('asesor') as FormControl;
  }
  get observationsControl(): FormControl {
    return this.formValidation.get('observations') as FormControl;
  }

  constructor(
    private formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    public helperService: HelperService,
    public typesOfService: APIService,
    public WorkshopService: APIWorkshopService,
    public AdvisorsService: APIServiceAdvisorService,
    public customerBasicDataService: APICustomerBasicDataService,
    public vehicleDataService: VehicleDataService,
    public customScheduleService: APICustomScheduleService,
    public schedulerService: APISchedulerService,
    public customersBasicData: APICustomerBasicDataService,
    public representativeDataService: APIRepresentativeService,
    public serviceScheduleService: APIServiceSchedule,
    public cityServiceApi: APIcityService,
    public attetionSchedulerservice: APIAttentionSchedule,
    public AdvisorScheduleService: APIServiceAdvisorSchedule,
    public serviceAdvisorBlockedScheduleService: APIServiceAdvisorBlockedSchedule,
    public dealerBlockedScheduleService: APIBlockedAttentionSchedules,
    public DealerBlockedServices: APIDealerBlockedServices,
    public APIServiceAdvisorBlockedSchedule: APIServiceAdvisorBlockedSchedule,
    public override publicSiteConfig: PublicSiteConfig,
    public APIServicetypeDocument: APIDocumentTypeService,
    private router: Router,private translate: TranslateService,
    private route: ActivatedRoute,
    public APItermAndPoliticsService: APITermsAndPolitics,private http: HttpClient
  ) {
    super(publicSiteConfig);
    if(!this.recievedScheduledData){
      this.route.params.subscribe(params => {
        this.indexbrand = params['brand'];
        this.indexCountry = params['country'];
      });
      const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`
      this.router.navigate([bannermanagementURL]);    
    }

  }

  protected override afterConfigLoaded(): void {
    // this.getWorkshopData();
     

    this.traductionData();
   
    this.route.params.subscribe(params => {
      this.indexbrand = params['brand'];
      this.indexCountry = params['country'];
      this.applyCountrySpecificValidators();
    });

    if(!this.recievedCountryData){

      const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`
      this.router.navigate([bannermanagementURL]);
    }

    this.APIServicetypeDocument.GetByCountryId(this.recievedCountryData).pipe(
      tap((response) => {
        if (!response.message) {
        this.documentType = response
        }
        else{}
      })).subscribe({
        error: (error) => {
          if(error.status === 401){
            const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`
            this.router.navigate([bannermanagementURL]);
            this.helperService.TokenBooking = ''
          }else{
            const translateTxtNotMatch = this.translate.instant("notMatchFound")
            this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTxtNotMatch
            setTimeout(() => {
              this.helperService.showAlert =false
              }, 7000)
          }
          
        }
      });

    this.route.params.subscribe(params => {
      this.brandUrl = params['brand'];
    })

    //Change the name of the brand for peru checkboxes
    this.brandNameOnlyPeru= this.CurrentBrand.name

    this.SelectSpecialCountry();
    this.getTermsAndConditions();

    this.bannerSuccesURL = `WebView/bannerSuccess/${this.brandUrl}/${this.recievedCountryData}`
    this.scheduleAppointmentURL = `WebView/bannerManage/${this.brandUrl}/${this.recievedCountryData}`

    this.loadPersonTypes();
    this.bindPersonTypeChanges();
    this.evaluateOldSchedule();
  } 

 
  enviarTokenAlBackend(token: string) {
    const payload = { secret:"6Le16I0rAAAAAHiHGgpYCROPeOtlCtExgZJwVSw6",
      response:token };

    this.http.post('https://www.google.com/recaptcha/api/siteverify', payload).subscribe(
      (res) => {
        console.log('Respuesta del backend:', res);
        // Aquí decides si dejas continuar al usuario o no
      },
      (error) => {
        console.error('Error en validación del captcha', error);
      }
    );
  }

  getTermsAndConditions(){
    this.APItermAndPoliticsService.termsAndPoliticsByBrandAndCountryId(Number(this.brandUrl), Number(this.recievedCountryData)).pipe(
      tap((results: TermsAndPolitics) => {
        this.termsPolitics = results

        if(this.termsPolitics[0].UrlAddress){
          this.termsAndConditionsLink = this.sanitizer.bypassSecurityTrustHtml(this.termsPolitics[0].UrlAddress);
        }

        if(this.termsPolitics[0].Description){
          this.safeTermsAndConditionsDescription = this.sanitizer.bypassSecurityTrustHtml(this.termsPolitics[0].Description)
        }

        if(this.termsPolitics[0].Observations){
          this.safeObservationsDescription = this.sanitizer.bypassSecurityTrustHtml(this.termsPolitics[0].Observations)
        }

        if(this.termsPolitics[0].DataProcessingPolicy){

          if(this.recievedCountryData !== 2 && this.recievedCountryData !== 1 ){
            this.safeDataProcessingPolicy = this.sanitizer.bypassSecurityTrustHtml(this.termsPolitics[0].DataProcessingPolicy)
          }else{
            const policies = this.termsPolitics[0].DataProcessingPolicy.replaceAll(/{{brandNameOnlyPeru}}/g, this.brandNameOnlyPeru as string)
            this.dataProcessingPolicy = this.extractPolicyValues(policies)
            this.safeDataProcessingPolicy = this.sanitizer.bypassSecurityTrustHtml(this.dataProcessingPolicy['1'])
            this.safeDataProcessingPolicyTrue = this.sanitizer.bypassSecurityTrustHtml(this.dataProcessingPolicy['2'])
            this.safeDataProcessingPolicyFalse = this.sanitizer.bypassSecurityTrustHtml(this.dataProcessingPolicy['3'])
          }
        }
      }
    )).subscribe({
      error: (error) => {
        if(error.status === 401){
          const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`
          this.router.navigate([bannermanagementURL]);
          this.helperService.TokenBooking = ''
        }else {
          this.termsAndConditionsLink = ""
          this.safeTermsAndConditionsDescription = ""
          this.safeObservationsDescription = ""
          this.dataProcessingPolicy = {}
        }
        
      }
    });
  }

  SelectSpecialCountry(){
    // Peru, Derco
    if (Number(this.recievedCountryData) === 2 && (Number(this.brandUrl) === 8 )){
      this.TermAndConditiosMode = "Derco"
    }
  }

  extractPolicyValues(text: string): {[key: string]: string}{
    const politics: {[key: string]: string} = {}
    const lines: string[] = text.trim().split('politics');
    lines.forEach(line => {
      const [key, value] = line.split(' = ');
      if (key && value) {
        politics[key.trim()] = value.trim();
      }
    });
    return politics;
  }

  traductionData(){
    this.disclaimer = this.translate.instant('disclamermilegs');
    this.tooltip = this.translate.instant('tooltip');
    this.tooltipWorkshop = this.translate.instant('tooltipWorkshop')

    this.PlaceHolderObservations= this.translate.instant('PlaceHolderObservations');
    this.SelectYourService= this.translate.instant('SelectYourService');
    this.FinalizeReservationr= this.translate.instant('FinalizeReservationr')
    this.CompleteData= this.translate.instant('CompleteData')
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (this.isTooltipVisible) {
      this.onIconClick('exclamation', 'bi-exclamation-circle', this.tooltipIcon);
    }
  }

  onIconMouseHoverAndOut(
    elementId: string,
    className: string,
    isFill: boolean
  ) {
    if (isFill) {
      document.getElementById(elementId)?.classList.add(className + '-fill');
      document.getElementById(elementId)?.classList.remove(className);
    } else {
      document.getElementById(elementId)?.classList.add(className);
      document.getElementById(elementId)?.classList.remove(className + '-fill');
    }
  }

  onIconClick(
    elementId: string,
    className: string,
    tooltip: MatTooltip
  ){
    this.isTooltipVisible = !this.isTooltipVisible;
    const element = document.getElementById(elementId);
    if (element){
      this.isTooltipIconFilled = !this.isTooltipIconFilled;
      tooltip.toggle();

      this.onIconMouseHoverAndOut(elementId, className, this.isTooltipIconFilled)
    }
  }

  ngOnDestroy(): void {
    this.onPlateAndDocumentSearchSubscription?.unsubscribe();
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
  }

  onChangeTypeOfService(id:number) {
    const dateTypeOfService = this.typesOfservice.filter(service => service.serviceId === id)[0]
    this.ToSName = dateTypeOfService;
    this.serviceIdResponse = dateTypeOfService.serviceId
    if (this.recievedScheduledData.id === '') {
    this.forChangeTypoOfService()}
    if(Number(this.brandUrl)=== 8){
        this.customScheduleService.getScheduleDropDownListsWebviewDerco(String(this.helperService?.filterType),Number(this.helperService?.retailId),Number(this.recievedBrandData),this.recievedCityData,this.serviceIdResponse).pipe(
          tap((response) => {
          if (!response.message) {
            this.workshops =  response
            if(this.recievedScheduledData.id !== '')this.onWorkshopChange(this.recievedScheduledData.workshopId)
          }
        })).subscribe({
          error: (error) => {
            if(error.status === 401){
              const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`
              this.router.navigate([bannermanagementURL]);
              this.helperService.TokenBooking = ''
            }else{
              const translateTxtNotMatch = this.translate.instant("notMatchFound")
              this.helperService.showAlert =true
              this.helperService.typeAlert ="error"
              this.helperService.messageAlert =translateTxtNotMatch
              setTimeout(() => {
                this.helperService.showAlert =false
              }, 7000)
            } 
          }
        });}
    else{

      this.customScheduleService.getScheduleDropDownListsWebview(String(this.helperService?.filterType),this.recievedCountryData,this.recievedBrandData,this.recievedCityData,this.serviceIdResponse).pipe(
        tap((response) => {
        if (!response.message) {
          this.workshops =  response
          if(this.recievedScheduledData.id !== '')this.onWorkshopChange(this.recievedScheduledData.workshopId)
        }
      })).subscribe({
        error: (error) => {
          if(error.status === 401){
            const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`
            this.router.navigate([bannermanagementURL]);
            this.helperService.TokenBooking = ''
          }else{
            const translateTxtNotMatch = this.translate.instant("notMatchFound")
            this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTxtNotMatch
            setTimeout(() => {
              this.helperService.showAlert =false
            }, 7000)
          }
          
        }
      });
  }



  }

  forChangeTypoOfService (){
    this.formValidation.value.asesor = 0
    this.formValidation.value.taller = undefined
    this.formValidation.value.kilometraje = undefined
    this.asesorControl.setValue("")
    this.advisorName =  ""
    this.tallerControl.setValue("")
    this.workShopName = ""
    this.kilometrajeControl.setValue([])
    this.mileages = []
    this.showCalendar = false;

  }

  onWorkshopChange(object:any) {
    this.showCalendar = false
    const dateWorkshop =  this.workshops.filter(service => service.workshopId === object)[0]
    this.workShopName = dateWorkshop.workshopName;
    this.workShopId = dateWorkshop.workshopId;
    let originalWorkshopId = dateWorkshop.originalWorkshopId
    const dayOfWeekMap = {
      Mon: 1,
      Tue: 2,
      Wed: 3,
      Thu: 4,
      Fri: 5,
      Sat: 6,
      Sun: 0,
    };
    this.dateDuration= dateWorkshop.dateLength;



    this.customScheduleService.getScheduleDropDownListsWebview(Number(this.brandUrl) === 8 ? 'Country' : String(this.helperService?.filterType ?? 'Country'),this.recievedCountryData,this.recievedBrandData,this.recievedCityData,this.serviceIdResponse,this.workShopId).pipe(tap((response) => {
      if (!response.message) {
        this.advisors =  response
        if(this.recievedScheduledData.id !== '') this.onAdvisorChange(this.recievedScheduledData.originalAdvisorId)
      }
    })).subscribe({
      error: (error) => {
        if(error.status === 401){
          const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`
          this.router.navigate([bannermanagementURL]);
          this.helperService.TokenBooking = ''
        }else{
          const translateTxtNotMatch = this.translate.instant("notMatchFound")
          this.helperService.showAlert =true
          this.helperService.typeAlert ="error"
          this.helperService.messageAlert =translateTxtNotMatch
          setTimeout(() => {
            this.helperService.showAlert =false
          }, 7000)
        }
        
      }
    });

  }
  private patchFromReceivedSchedule(): void {
    const s = this.recievedScheduledData;
    if (s && s.clientLastName === 'NaN') { this.disableApellidos(); return; } 
    if (!s || s.id === '' || s.id == null) return;
    this.formValidation2.patchValue({
      personTypeId: Number(s.personTypeId ?? null),
      tip_Doc: Number(s.typeOfDocument ?? 0),

    }, { emitEvent: false });
    const patchedPersonTypeId = Number(s.personTypeId ?? null);
    if (patchedPersonTypeId) {
      this.onPersonTypeChange(patchedPersonTypeId);
    }
    this.serviceIdResponse = Number(s.originalServiceId ?? s.serviceId);
  }
  
  private lockPersonTypeAndDoc(): void {
    this.personTypeIdControl.disable({ emitEvent: false });
    this.tip_DocControl.disable({ emitEvent: false });
    this.cedulaControl.disable({ emitEvent: false });

    this.personTypeIdControl.updateValueAndValidity({ emitEvent: false });
    this.tip_DocControl.updateValueAndValidity({ emitEvent: false });
    this.cedulaControl.updateValueAndValidity({ emitEvent: false });
  }

  private unlockPersonTypeAndDoc(): void {
    this.personTypeIdControl.enable({ emitEvent: false });
    this.tip_DocControl.enable({ emitEvent: false });
    this.cedulaControl.enable({ emitEvent: false });

    this.personTypeIdControl.updateValueAndValidity({ emitEvent: false });
    this.tip_DocControl.updateValueAndValidity({ emitEvent: false });
    this.cedulaControl.updateValueAndValidity({ emitEvent: false });
  }

  private disableApellidos(): void {
    const ctrl = this.apellidosControl;

    ctrl.setValue('', { emitEvent: false });
    ctrl.clearValidators();
    ctrl.disable({ emitEvent: false });
    ctrl.updateValueAndValidity({ emitEvent: false });

    this.showApellidos = false;
    this.companyType='Company'
    this.formValidation2.value.apellidos = 'NaN';
  }

  private enableApellidos(): void {
    const ctrl = this.apellidosControl;

    ctrl.enable({ emitEvent: false });
    ctrl.setValidators([Validators.required, noSpecialCharsValidator]);
    ctrl.updateValueAndValidity({ emitEvent: false });
    this.companyType='Individual'
    this.showApellidos = true;
  }

  private loadPersonTypes(): void {
    this.APIServicetypeDocument.GetPersonTypeByCountryId(Number(this.recievedCountryData))
      .pipe(
        tap((resp) => {
          this.personTypes = resp ?? [];
        })
      )
      .subscribe({
        error: (error) => {
          if (error.status === 401) {
            const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`;
            this.router.navigate([bannermanagementURL]);
            this.helperService.TokenBooking = '';
          }
        }
      });
  }

  private applyCountrySpecificValidators(): void {
    const isColombia = Number(this.indexCountry) === 1;
    const onlyNumbers = Validators.pattern(/^[0-9]+$/);


    const cedulaValidators = isColombia
      ? [Validators.required, Validators.minLength(8), Validators.maxLength(11)]
      : [Validators.required, Validators.minLength(5)];

    const celularValidators = isColombia
      ? [Validators.required, onlyNumbers, Validators.minLength(7), Validators.maxLength(10)]
      : [Validators.required, noSpecialCharsValidator];

    const repDocValidators = isColombia
      ? [Validators.required, Validators.minLength(8), Validators.maxLength(11)]
      : [Validators.required, Validators.pattern(/^[a-zA-Z0-9\-]*$/), Validators.minLength(5)];

    const repPhoneValidators = isColombia
      ? [Validators.required, onlyNumbers, Validators.minLength(7), Validators.maxLength(10)]
      : [Validators.required, noSpecialCharsValidator];

    this.cedulaControl.setValidators(cedulaValidators);
    this.celControl.setValidators(celularValidators);
    this.representativeDocumentNumberControl.setValidators(repDocValidators);
    this.representativePhoneControl.setValidators(repPhoneValidators);

    this.cedulaControl.updateValueAndValidity({ emitEvent: false });
    this.celControl.updateValueAndValidity({ emitEvent: false });
    this.representativeDocumentNumberControl.updateValueAndValidity({ emitEvent: false });
    this.representativePhoneControl.updateValueAndValidity({ emitEvent: false });

    if (this.isPeruSpecialBrand()) {
      this.dataProtectionPoliticsControl.clearValidators();
      this.formValidation2.get('dataPeru')?.setValidators(Validators.required);
    } else {
      this.dataProtectionPoliticsControl.setValidators(Validators.required);
      this.formValidation2.get('dataPeru')?.clearValidators();
    }
    this.dataProtectionPoliticsControl.updateValueAndValidity({ emitEvent: false });
    this.formValidation2.get('dataPeru')?.updateValueAndValidity({ emitEvent: false });
  }

  onPersonTypeChange(personTypeId: number | null): void {
   this.companyType === 'Company'? this.disableApellidos() :this.enableApellidos();    
    if (!personTypeId) {
      this.documentType = [];      
      this.formValidation2.patchValue({ tip_Doc: 0 }, { emitEvent: false });
      return;
    }

    this.APIServicetypeDocument
      .GetDocumentTypeByCountryIdByPersonId(Number(this.recievedCountryData), Number(personTypeId))
      .pipe(
        tap((resp: any) => {          
          this.documentType = resp ?? [];
          const desired = Number(this.recievedScheduledData?.typeOfDocument ?? this.userData?.typeId ?? 0);
          const exists = this.documentType.some((d: any) => Number(d.typeId) === desired);

          if (exists) {
            this.tip_DocControl.setValue(desired, { emitEvent: false });
          } else {
            this.tip_DocControl.setValue(0, { emitEvent: false });
          }
        })
      )
      .subscribe({
        error: (error) => {
          if (error.status === 401) {
            const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`;
            this.router.navigate([bannermanagementURL]);
            this.helperService.TokenBooking = '';
          }
        }
      });
  }

  private bindPersonTypeChanges(): void {
    this.formValidation2.get('personTypeId')?.valueChanges.subscribe((id) => {
       this.selectedPersonType =
      this.personTypes.find((p: any) => Number(p.typeId) === id) ?? null;
      const label = (this.selectedPersonType?.typeLabel ?? '').trim();
      this.companyType = label === 'Company' ? 'Company' : 'Individual';
      this.onPersonTypeChange(id as number | null);
    });
  }
serchModels(){
   // reset fields
   
    this.loadingSerchPlate = true
   
    this.vehicleDataService
      .getValidatedDataWithCountryAndbrand(this.placaControl.value,Number(this.recievedBrandData ), this.cedulaControl.value)
      .pipe(
        tap((response) => {
          this.modelVehicle = response.vehicleModelInfo.models
          const model = response.vehicleModelInfo.modelDescription;

           this.EnableVehicleandModel = !!model && model.trim() !== "";
          // if(response.vehicleModelInfo.modelDescription !== null || response.vehicleModelInfo.modelDescription !== "") {this.EnableVehicleandModel = true  
          //   console.log("1")}
          // else{this.EnableVehicleandModel = false
          //    console.log("1")}
          this.loadingSerchPlate = false
        }),

      )
      .subscribe({
        error: (error) => {
          if (error.status === 401) {
            const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`;
            this.router.navigate([bannermanagementURL]);
            this.helperService.TokenBooking = '';
          }else{
            console.log(error)
            const translateTxtNotMatch = this.translate.instant("Errorcharacters")
            this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTxtNotMatch
            setTimeout(() => {
              this.helperService.showAlert =false
            }, 7000)

            this.loadingSerchPlate = false
          }    
    }});
  
}
  evaluateOldSchedule() {
  //  console.log(this.recievedScheduledData)
    if (this.recievedScheduledData.id !== '') {
    
      this.isNewUser = false;
      this.recievedCityData = this.recievedScheduledData.cityId
      this.selectOwnerOnSite = this.recievedScheduledData.ownerOnSite.toString()
      this.isOwnerOnSite = this.recievedScheduledData.ownerOnSite
      this.formValidation.patchValue({
        tip_service: Number(this.recievedScheduledData.originalServiceId),
        observations: this.recievedScheduledData.observations,
        kilometraje: this.recievedScheduledData.kilometraje,
        taller:this.recievedScheduledData.workshopId,
        asesor:this.recievedScheduledData.originalAdvisorId
      });
      this.formValidation2.patchValue({
        placa: this.recievedScheduledData.plateNo,
        cedula: this.recievedScheduledData.documentNumber,
        tip_Doc: Number(this.recievedScheduledData.typeOfDocument),
        nombres: this.recievedScheduledData.clientFirstName,
        apellidos: this.recievedScheduledData.clientLastName,
        celular: this.recievedScheduledData.contactNumber,
        correo: this.recievedScheduledData.email,
        vin: this.recievedScheduledData.vinNo,
        cod_pais: '+57',
        año:this.recievedScheduledData.modelYear,
        model:this.recievedScheduledData.modelDescription

      });
      this.serchModels()
      this.serchrepresentrative()
      this.lockPersonTypeAndDoc();
      this.cityName =this.recievedScheduledData.city
      this.customScheduleService.getScheduleDropDownListsWebview(Number(this.brandUrl) === 8 ? 'Country' : String(this.helperService?.filterType ?? 'Country'),this.recievedCountryData,Number(this.recievedBrandData),this.recievedScheduledData.cityId).pipe(tap((response) => {
        if (!response.message) {
          this.typesOfservice =  response
          this.onChangeTypeOfService(Number(this.recievedScheduledData.originalServiceId))
        }
      })).subscribe({
        error: (error) => {
          if(error.status === 401){
            const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`
            this.router.navigate([bannermanagementURL]);
            this.helperService.TokenBooking = ''
          }else{
            const translateTxtNotMatch = this.translate.instant("notMatchFound")
            this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTxtNotMatch
            setTimeout(() => {
              this.helperService.showAlert =false
            }, 7000)
          }
          
        }
      });
      // this.typesOfservice$ = this.customScheduleService.getScheduleDropDownListsWebview(this.recievedCountryData,this.recievedBrand,this.recievedScheduledData.cityId);
      // this.workshops$ = this.customScheduleService.getScheduleDropDownListsWebview(this.recievedCountryData,this.recievedBrand,this.recievedScheduledData.cityId,this.recievedScheduledData.originalServiceId );
      this.serviceIdResponse = this.recievedScheduledData.originalServiceId
    }
    else{
      
     this.customScheduleService.getScheduleDropDownListsWebview(Number(this.brandUrl) === 8 ? 'Country' : String(this.helperService?.filterType ?? 'Country'),this.recievedCountryData,this.recievedBrandData,this.recievedCityData).pipe(tap((response) => {
       if (!response.message) {
          this.typesOfservice =  response
        }
      })).subscribe({
        error: (error) => {
          if(error.status === 401){
            const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`
            this.router.navigate([bannermanagementURL]);
            this.helperService.TokenBooking = ''
          }else{
            const translateTxtNotMatch = this.translate.instant("notMatchFound")
            this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTxtNotMatch
            setTimeout(() => {
              this.helperService.showAlert =false
              }, 7000)
          }
          
        }
      });
      this.unlockPersonTypeAndDoc();
    }
    this.patchFromReceivedSchedule();
    this.recievedScheduledData.id !== '' ? this.lockPersonTypeAndDoc() : this.unlockPersonTypeAndDoc();   
       this.recievedScheduledData.clientLastName==='NaN'?this.disableApellidos():this.enableApellidos();
  }

  serchrepresentrative() {
    this.vehicleDataService .getValidatedData(this.recievedScheduledData.plateNo, this.recievedScheduledData.documentNumber).pipe(
      tap((response) => {
        if (!response.message) {
          this.userData = response;
          const rawConsent = this.recievedCountryData === 2
            ? (this.recievedScheduledData?.dataPrivacy ?? this.recievedScheduledData?.DataPrivacy)
            : (this.recievedScheduledData?.dataProtectionPolitics ?? this.recievedScheduledData?.DataProtectionPolitics);
          const previousConsent = this.parseConsent(rawConsent);
          this.formValidation2.patchValue({ politics: previousConsent, dataPeru: previousConsent });


          this.representativeDataService.getForCustomerId(this.userData.customerId).pipe(
            tap((response) => {

              if (!response.message) {

              this.representativeDatacountry = response;
              this.formValidation_representative.patchValue({
                representativeDocumentNumber: this.representativeDatacountry.identification,
                representativeName:this.representativeDatacountry.firstName,
                representativeLastName:this.representativeDatacountry.lastName,
                representativePhone:this.representativeDatacountry.phone,
                representativeCountryCode:'57',
                representativeDocumentType: this.representativeDatacountry.documentType,
                representativecorreo:this.representativeDatacountry.email,

              })

              }
              else{
                this.representativeDatacountry ={representativeId:0}
                this.formValidation_representative.patchValue({
                  representativeDocumentNumber: '',
                  representativeName:'',
                  representativeLastName:'',
                  representativePhone:'',
                  representativeCountryCode:'',
                  representativeDocumentType:'',
                  representativecorreo:'',
                })
              }
            })

          )
          .subscribe();
        } else {
          // this.userData=[{vehicleId : 0,customerId : 0}]
          this.userData = [{vehicleId : 0,customerId : 0}]
          this.representativeDatacountry ={representativeId:0}

          this.formValidation2.patchValue({
            tip_Doc: 0,
            nombres: '',
            apellidos: '',
            cod_pais: '',
            celular: '',
            correo: '',
            vin: '',
            terms: false,
            politics: null,
            dataPeru: null,
          });
          this.formValidation_representative.patchValue({
            representativeDocumentNumber: '',
            representativeName:'',
            representativeLastName:'',
            representativePhone:'',
            representativeCountryCode:'',
            representativeDocumentType:'',
            representativecorreo:'',
          })
        }
      }),
    ).subscribe({
      error: (error) => { 
        if (error.status === 401) {
          const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`;
          this.router.navigate([bannermanagementURL]);
          this.helperService.TokenBooking = '';
        } else if (Number(this.recievedCountryData) === 9) { // Si no es 401, pero sí es countryData 9
          this.representativeDataService.getForCustomerId(this.recievedScheduledData.customerId)
            .pipe(
              tap((response) => {
                if (!response.message) {
                  this.representativeDatacountry = response;
                  this.formValidation_representative.patchValue({
                    representativeDocumentNumber: this.representativeDatacountry.identification,
                    representativeName: this.representativeDatacountry.firstName,
                    representativeLastName: this.representativeDatacountry.lastName,
                    representativePhone: this.representativeDatacountry.phone,
                    representativeCountryCode: '57',
                    representativeDocumentType: this.representativeDatacountry.documentType,
                    representativecorreo: this.representativeDatacountry.email,
                  });
                } else {
                  this.representativeDatacountry = { representativeId: 0 };
                  this.formValidation_representative.patchValue({
                    representativeDocumentNumber: '',
                    representativeName: '',
                    representativeLastName: '',
                    representativePhone: '',
                    representativeCountryCode: '',
                    representativeDocumentType: '',
                    representativecorreo: '',
                  });
                }
              })
            )
            .subscribe();
        } else { 
          const translateTxtNotMatch = this.translate.instant("notMatchFound");
          this.helperService.showAlert = true;
          this.helperService.typeAlert = "error";
          this.helperService.messageAlert = translateTxtNotMatch;
          setTimeout(() => {
            this.helperService.showAlert = false;
          }, 7000);
        }
      }
    });    
  }
  
  daysForMonthNow(year,mounth,day) {
    var date = new Date(year+"/"+mounth+"/"+day);
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  }

  DateFilter = (date: Date | any) => {
    let day = date.getDay();
    this.busyDates = this.serviceAdvisorAttention.map((s) => s.dayNumber);
    let limitDate = new Date(new Date().getFullYear() + '-' +('0' + (new Date().getMonth() + 6) ).slice(-2) + '-' + this.daysForMonthNow(new Date().getFullYear() ,new Date().getMonth() + 6,"01") + 'T23:59')
    if(new Date().getMonth() + 7 > 12){
      limitDate = new Date(new Date().getFullYear()+1 + '-' +('0' + (new Date().getMonth() + 7 - 12) ).slice(-2) + '-' + this.daysForMonthNow(new Date().getFullYear()+1 ,new Date().getMonth() + 7 - 12,"01") + 'T23:59')
    }
    const limitDatenumber = limitDate.getTime()
     return (
      date.setHours(0, 0, 0, 0)>new Date().setHours(0, 0, 0, 0) &&(
      day === this.busyDates[0] ||
      day === this.busyDates[1] ||
      day === this.busyDates[2] ||
      day === this.busyDates[3] ||
      day === this.busyDates[4] ||
      day === this.busyDates[5] ||
      day === this.busyDates[6] )
      && date<=limitDatenumber
     );
  };

  backInitialChoose(){
    this.router.navigate([this.scheduleAppointmentURL]);
  }

  onAdvisorChange(value) {
    const dateAdvisor =  this.advisors.filter(service => service.advisorId === value)[0]
    this.advisorName = dateAdvisor.advisorFullName ;
    this.advisorId = dateAdvisor.advisorId
    let advisordataCustom
    this.showCalendar = false
    this.isLoadingCalendar = true


    this.customScheduleService.getSchedulerByAdvisor( value).pipe(  map((response)=>{
      advisordataCustom =response
      this.dealerBlockedServices= advisordataCustom.blockedservicesByServiceAdvisor.filter(lockworkshop=>lockworkshop.brandId === Number(this.recievedBrandData))
      this.serviceAdvisorBlockedSchedule = advisordataCustom.serviceAdvisorBlockedServices.filter(lockworkshop=>lockworkshop.brandId === Number(this.recievedBrandData))
     this.SchedulForAdvisor =advisordataCustom.customAdvisorSchedule

      //event is the service advisorID
    this.AdvisorScheduleService.getByAdvisor(value).pipe(tap((response) => {

      if (!response.message) {

        response = response.filter((r) => r.isActive === true);
        this.serviceAdvisorAttention = response;
        this.showCalendar = false;
        this.DateFilter(new Date());
        if (value) {
          setTimeout(() => {
            this.isLoadingCalendar = false;
            this.showCalendar = true;

          }, 1);
        }

        this.date = '';
        this.time = '';
      }
      else{

        this.serviceAdvisorAttention=[]
        this.isLoadingCalendar = false;
        this.showCalendar = true;
      }
    },
  )).subscribe({
    error: (error) => {
      if (error.status === 401) {
        const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`;
        this.router.navigate([bannermanagementURL]);
        this.helperService.TokenBooking = '';
      }else{
        const translateTxtNotMatch = this.translate.instant("notMatchFound")
        this.helperService.showAlert =true
        this.helperService.typeAlert ="error"
        this.helperService.messageAlert =translateTxtNotMatch
        setTimeout(() => {
          this.helperService.showAlert =false
        }, 7000)
      }
    }
  });

    ; })).subscribe({
      error: (error) => {
        if (error.status === 401) {
          const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`;
          this.router.navigate([bannermanagementURL]);
          this.helperService.TokenBooking = '';
        } else{
          const translateTxtNotMatch = this.translate.instant("notMatchFound")
          this.helperService.showAlert =true
          this.helperService.typeAlert ="error"
         this.helperService.messageAlert =translateTxtNotMatch
          setTimeout(() => {
            this.helperService.showAlert =false
          }, 7000)
          this.loadingSerchPlate = false
        }
        
      }
    })



  }

  isNewSchedule(): boolean {
    return this.recievedScheduledData.id === '';
  }

  private parseConsent(value: any): boolean | null {
    if (value === true || value === 1 || value === 'True' || value === 'true') return true;
    if (value === false || value === 0 || value === 'False' || value === 'false') return false;
    return null;
  }

  isPeruSpecialBrand(): boolean {
    return this.recievedCountryData === 2 && [4, 5, 6].includes(Number(this.indexbrand));
  }

  toBoolean(event) {
    const value = event.target.value;

    this.isOwnerOnSite = value === 'true';
  }

  onPlateNumberSearchClick() {
    // reset fields
    this.isNewUser = true;
    this.edited=false
    this.edited2=false
    this.loadingSerchPlate = true
    this.formValidation2.patchValue({
      tip_Doc: 0,
      nombres: '',
      apellidos: '',
      cod_pais: '',
      celular: '',
      correo: '',
      vin: '',
      terms: false,
      politics: null,
      dataPeru: null,
      cedula:this.cedulaControl.value
    });

    this.vehicleDataService
      .getValidatedDataWithCountryAndbrand(this.placaControl.value,this.recievedBrandData , this.cedulaControl.value)
      .pipe(
        tap((response) => {
          this.modelVehicle = response.vehicleModelInfo.models
              const model = response.vehicleModelInfo.modelDescription;

           this.EnableVehicleandModel = !!model && model.trim() !== "";
          this.userSearched = true;
          if (response.customerId !== 0) {
            
            this.userData = response;
            this.isNewUser = false;
            this.edited=true
            this.edited2=true
            this.loadingSerchPlate = false
            this.formValidation2.patchValue({
              cedula: this.userData.identification,
              tip_Doc: this.userData.typeId ,
              personTypeId:this.userData.personTypeId,
              nombres: this.userData.firstName,
              apellidos: this.userData.lastName,
              cod_pais: '',
              celular: this.userData.phone,
              correo: this.userData.email,
              vin: this.userData.vin,
              model: this.userData.vehicleModelInfo.modelDescription,
              año: this.userData.vehicleModelInfo.modelYear,
              terms: false,
              politics: this.parseConsent(this.userData.dataPrivacy),
              dataPeru: this.parseConsent(this.userData.dataPrivacy),

            }
            );
            this.lockPersonTypeAndDoc();
            this.representativeDataService.getForCustomerId(this.userData.customerId).pipe(
              tap((response) => {

                if (!response.message) {

                this.representativeDatacountry = response;
                this.formValidation_representative.patchValue({
                  representativeDocumentNumber: this.representativeDatacountry.identification,
                  representativeName:this.representativeDatacountry.firstName,
                  representativeLastName:this.representativeDatacountry.lastName,
                  representativePhone:this.representativeDatacountry.phone,
                  representativeCountryCode:'',
                  representativeDocumentType: this.representativeDatacountry.documentType,
                  representativecorreo:this.representativeDatacountry.email
                })

                }
                else{

                  this.representativeDatacountry ={representativeId:0}
                  this.formValidation_representative.patchValue({
                    representativeDocumentNumber: '',
                    representativeName:'',
                    representativeLastName:'',
                    representativePhone:'',
                    representativeCountryCode:'',
                    representativeDocumentType:'',
                    representativecorreo:'',
                  })
                }
              })

            )
            .subscribe();
            this.loadingSerchPlate = false
          } else {
            // this.userData=[{vehicleId : 0,customerId : 0}]
            this.userData = [{vehicleId : 0,customerId : 0}]
            this.representativeDatacountry ={representativeId:0}

            this.formValidation2.patchValue({
              tip_Doc: 0,
              nombres: '',
              apellidos: '',
              cod_pais: '',
              celular: '',
              correo: '',
              model: null,
              año: null,
              vin: '',
              terms: false,
              politics: null,
              dataPeru: null,
              cedula:this.cedulaControl.value
            });
            this.unlockPersonTypeAndDoc();
            this.formValidation_representative.patchValue({
              representativeDocumentNumber: '',
              representativeName:'',
              representativeLastName:'',
              representativePhone:'',
              representativeCountryCode:'',
              representativeDocumentType:'',
              representativecorreo:'',
            })
          }

          this.details = true;
          this.loadingSerchPlate = false
        }),

      )
      .subscribe({
        error: (error) => {
          if (error.status === 401) {
            const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`;
            this.router.navigate([bannermanagementURL]);
            this.helperService.TokenBooking = '';
          }else{
            console.log(error)
            this.representativeDatacountry ={representativeId:0}
            const translateTxtNotMatch = this.translate.instant("Errorcharacters")
            this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTxtNotMatch
            setTimeout(() => {
              this.helperService.showAlert =false
            }, 7000)

            this.loadingSerchPlate = false
          }    
    }});
  }

  nextDisabled(): boolean {
    if (this.date === undefined || this.date === '' || this.time === '' ||  this.formValidation.invalid) {
      return true;
    } else return false;
  }

  transformInput({ target }) {
    target.value = target.value.toUpperCase().replace(/\s/g, '');
  }

  filterDocumentByCountry(event: Event, control: AbstractControl): void {
    const input = event.target as HTMLInputElement;
    const isColombia = Number(this.recievedCountryData) === 1;

    const cleaned = isColombia
      ? input.value.replace(/[^0-9]/g, '')                              
      : input.value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '');

    input.value = cleaned;
    control.setValue(cleaned, { emitEvent: false });
  }

  filterPhoneByCountry(event: Event, control: AbstractControl): void {
    const input = event.target as HTMLInputElement;
    const isColombia = Number(this.recievedCountryData) === 1;

    const cleaned = isColombia
      ? input.value.replace(/[^0-9]/g, '')
      : input.value.replace(/[^0-9\+]/g, '');

    input.value = cleaned;
    control.setValue(cleaned, { emitEvent: false });
  }

  isOwner(e) {
    if (e.target.value === 'false') {
      this.owner = false;
    } else {
      this.owner = true;
    }
  }

  NameDocument()
  {
    const raw = this.formValidation2.getRawValue();
    const docId = Number(raw.tip_Doc ?? 0);

    this.nameDocumentType =
      this.documentType.find((s: any) => Number(s.typeId) === docId) ?? null;
  }

  ejecutarCaptcha() {
      grecaptcha.ready(() => {
      grecaptcha.execute(this.helperService.siteKeyCatcha, { action: 'login' }).then((token: string) => {
        this.onSave(token);
        // Enviar token al backend
      });
    });
  }

  onSave(token:string) {
    // POST

    let customschedulerData :CreateSchedulerData | any
     this.isLoading = true;
    const rawValue = this.formValidation2.getRawValue();
    if (this.recievedScheduledData.id === '') {
      // picked date om bd format
      let bdDateFormat = this.date.split('/');
      bdDateFormat = `${bdDateFormat[2]}-${bdDateFormat[1]}-${bdDateFormat[0]}`;
      let bdTimeFormat = moment(this.time, ['h:mm A']).format('HH:mm:ss');

      customschedulerData = {
        createSchedulerDTO:{
          scheduleId:0,
          customerId: this.userData.customerId ,
          advisorId:  Number(this.formValidation.value.asesor),
          vehicleId:  this.userData.vehicleId,
          date: bdDateFormat,
          time: bdTimeFormat,
          observations:  String( this.formValidation.value.observations ),
          ownerOnSite:  this.isOwnerOnSite,
          termsAndConditions:Boolean( this.formValidation2.value.terms ),
          dataProtectionPolitics: Boolean( this.formValidation2.value.politics),
          representativeId: this.representativeDatacountry.representativeId,
          decisionMaking:  true,
          countryBrandRetailId: this.workShopId,
          schedulerStatusId:  1,
          serviceId:  Number(this.formValidation.value.tip_service),
          originId:  4,
          DataProcessing:Boolean( this.formValidation2.value.politics),
          UserId: 0
        },

      vehicleDataDTO: {
        vehicleId: this.userData.vehicleId,
        plate:  String(this.formValidation2.value.placa),
        vin: this.isNewUser ?  "": String(this.formValidation2.value.vin),
        color: '',
        brand: this.vehicleBrand,
        mileage: String(this.formValidation.value.kilometraje),
        customerId: this.userData.customerId,
        ModelDescription: String(this.formValidation2.value.model),
        ModelYear: String(this.formValidation2.value.año)
      },
      customerBasicDataDTO: {
        customerId: this.userData.customerId,
        sapCustomerId: "0",
        identification: String(rawValue.cedula),
        personTypeId: Number(rawValue.personTypeId),
        documentType: Number(rawValue.tip_Doc),
        firstName:  String(this.formValidation2.value.nombres),
        lastName: this.companyType==='Individual'? String(this.formValidation2.value.apellidos):'NaN',
        email: String(this.formValidation2.value.correo),
        phone: String(this.formValidation2.value.celular),
        address: "",
        relationshipVehicleId: 1,
        dataPrivacy: this.recievedCountryData === 2 ? Boolean(this.formValidation2.value.dataPeru) : Boolean( this.formValidation2.value.politics)
      },
      representativeDTO: {
        representativeId: this.representativeDatacountry.representativeId,
        customerId: this.userData.customerId,
        identification: String( this.formValidation_representative.value.representativeDocumentNumber ),
        documentType: Number( this.formValidation_representative.value.representativeDocumentType ),
        firstName: String( this.formValidation_representative.value.representativeName ),
        lastName:  String(this.formValidation_representative.value.representativeLastName),
        email:String(this.formValidation_representative.value.representativecorreo),
        phone: String(this.formValidation_representative.value.representativePhone),
        address: ""
      },utmDTO: this.utmParams,
      RecaptchaToken:token


      }



      this.schedulerService.postDataScheduler(customschedulerData).pipe(
        tap((response) => {
          this.isLoading = false;
          response.dataLayer[0].event = 'ServiceBooking_Lead';
          this.router.navigate([this.bannerSuccesURL], { state: { AppointmentInfo: response.dataLayer[0] } });
        }),
        catchError((error): Observable<any> => {
          if (error.status === 401) { 
            const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`;
            this.router.navigate([bannermanagementURL]);
            this.helperService.TokenBooking = '';
          } else { 
            console.error('Error:', error);
            const translateTextError = this.translate.instant('ToastErrorAppointment');
            this.helperService.showAlert = true;
            this.helperService.typeAlert = "error";
            this.helperService.messageAlert = translateTextError;
      
            setTimeout(() => {
              this.helperService.showAlert = false;
            }, 7000);
      
            setTimeout(() => {
              this.router.navigate([this.scheduleAppointmentURL]); 
            }, 7000);
          }
          return of(null); 
        })
      ).subscribe();
      

    } else {

      // UPDATE DATA ON BACKEND (PUT)

      let bdDateFormat = this.date.split('/');
      bdDateFormat = `${bdDateFormat[2]}-${bdDateFormat[1]}-${bdDateFormat[0]}`;
      let bdTimeFormat = moment(this.time, ['h:mm A']).format('HH:mm:ss');

      customschedulerData = {
        createSchedulerDTO:{
          scheduleId:this.recievedScheduledData.id,
          customerId: this.recievedScheduledData.customerId ,
          advisorId: Number(this.formValidation.value.asesor),
          vehicleId:  this.recievedScheduledData.vehicleId,
          date: bdDateFormat,
          time: bdTimeFormat,
          observations:  String( this.formValidation.value.observations ),
          ownerOnSite:  this.isOwnerOnSite,
          termsAndConditions:Boolean( this.formValidation2.value.terms ),
          dataProtectionPolitics: Boolean( this.formValidation2.value.politics),
          representativeId: this.representativeDatacountry.representativeId,
          decisionMaking:  true,
          countryBrandRetailId: this.workShopId,
          schedulerStatusId:  4,
          serviceId:  Number(this.formValidation.value.tip_service),
          originId:  4,
          DataProcessing:Boolean( this.formValidation2.value.politics),
           UserId: 0
        },

      vehicleDataDTO: {
        vehicleId: this.recievedScheduledData.vehicleId,
        plate:  String(this.formValidation2.value.placa),
        vin:  this.isNewUser ?  "": String(this.formValidation2.value.vin),
        color: '',
        brand: this.vehicleBrand,
        mileage: String(this.formValidation.value.kilometraje),
        customerId: this.recievedScheduledData.customerId,
        ModelDescription: String(this.formValidation2.value.model),
        ModelYear: String(this.formValidation2.value.año)
      },
      customerBasicDataDTO: {
        customerId: this.recievedScheduledData.customerId,
        sapCustomerId: "0",
        identification: String(rawValue.cedula),
        personTypeId: Number(rawValue.personTypeId),
        documentType: Number(rawValue.tip_Doc),
        firstName:  String(this.formValidation2.value.nombres),
        lastName: this.companyType==='Individual'? String(this.formValidation2.value.apellidos):'NaN',
        email: String(this.formValidation2.value.correo),
        phone: String(this.formValidation2.value.celular),
        address: "",
        relationshipVehicleId: 1,
        dataPrivacy: this.recievedCountryData === 2 ? Boolean(this.formValidation2.value.dataPeru) : Boolean( this.formValidation2.value.politics)
      },
      representativeDTO: {
        representativeId: this.representativeDatacountry.representativeId,
        customerId: this.recievedScheduledData.customerId,
        identification: String( this.formValidation_representative.value.representativeDocumentNumber ),
        documentType: Number( this.formValidation_representative.value.representativeDocumentType ) || 0,
        firstName: String( this.formValidation_representative.value.representativeName ),
        lastName:  String(this.formValidation_representative.value.representativeLastName),
        email: String(this.formValidation_representative.value.representativecorreo),
        phone: String(this.formValidation_representative.value.representativePhone),
        address: ""
      },
      utmDTO: this.utmParams,
      RecaptchaToken:token

      }


      this.schedulerService.postDataScheduler(customschedulerData).pipe(tap( () =>{
        this.isLoading = false;
        this.router.navigate([this.bannerSuccesURL], {
          state: { AppointmentInfo: "rescheduler Appintment"},
        });
      }
      ),catchError((error): Observable<any> => {
        if (error.status === 401) {
          const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`;
          this.router.navigate([bannermanagementURL]);
          this.helperService.TokenBooking = ''; 
        } else { 
          console.error('Error:', error);
          const translateTextError = this.translate.instant('ToastErrorAppointment');
          this.helperService.showAlert = true;
          this.helperService.typeAlert = "error";
          this.helperService.messageAlert = translateTextError;
      
          setTimeout(() => {
            this.helperService.showAlert = false;
          }, 7000);
      
          setTimeout(() => {
            this.router.navigate([this.scheduleAppointmentURL]); 
          }, 7000);
        }
      
        return of(null);
      }))
      .subscribe();
    }
  }

  OwnerOnSite(e: any) {
    this.isOwnerOnSite = e.value === 'true';
  }

  timeValue(e) {
    this.time = e;
  }
  dateValue(e) {
    this.date = e;
  }
  toNumber(value): number {
    return value;
  }

  SerchPlate():boolean{
    if(String(this.formValidation2.value.placa)!=="" && String(this.formValidation2.value.cedula).length >=5){

      return false
    }
    else{ return true}
  }

  formsValidations(): boolean {
    if(this.isOwnerOnSite){return this.formValidation2.invalid }

  else{
    if( this.formValidation2.invalid ) {return true}
    else {return this.formValidation_representative.invalid}
  }
  }
}
